"use client";

import { useQuery } from "@tanstack/react-query";
import { getProductsList } from "@/modules/products/actions/products";
import { HttpTypes } from "@medusajs/types";
import { useLocationStore } from "@/store/index";

interface UseProductsParams {
  countryCode?: string;
  regionId?: string;
  currencyCode?: string;
  queryParams?: HttpTypes.StoreProductListParams;
}

export const useProducts = ({
  countryCode,
  regionId,
  currencyCode,
  queryParams,
}: UseProductsParams) => {
  const { province, municipality } = useLocationStore();

  return useQuery({
    queryKey: ["products", countryCode, regionId, currencyCode, queryParams, province, municipality],
    queryFn: async () => {
      const { response } = await getProductsList({
        countryCode,
        regionId,
        currency_code: currencyCode,
        queryParams,
        province: province || undefined,
        municipality: municipality || undefined,
      });
      return response;
    },
    enabled: !!(countryCode || regionId),
  });
};
